export default "__VITE_ASSET__CWt4pDR$__"